/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

// Получаем значение объекта и выводим ошибку в консоль если нет такого значения.
export function get(object, path, defaultValue) {
  if (!_.hasIn(object, path) && defaultValue !== null) {
    // eslint-disable-next-line dot-notation
    if (process.env['ENV_TYPE'] === 'development') {
      console.error(`Не удалось найти параметр объекта ${path} in:`);
      console.error(object);
    }
    return null;
  }
  return _.get(object, path, defaultValue);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/lodashCustom.js